// @flow

import { KEY_ELECTRONIC_IDS } from '@flow/libs/extensions';

const ElectronicIds = {
  key: KEY_ELECTRONIC_IDS,
};

export default ElectronicIds;
